export function arrayContains(array: any[], value: any) {
  return array.indexOf(value) !== -1;
}

export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));
